import { from } from 'rxjs';
import loadFirebase, { getFirebaseApp } from '../firebase';
import { getImpersonationSession } from '../../helpers/impersonation';

let database = null;
let databasePromise = null;
let emulatorConnected = false;

const loadDatabase = async () => {
    await loadFirebase();
    await import('firebase/compat/firestore');

    const db = getFirebaseApp().firestore();

    try {
        if (!getImpersonationSession()) await db.enablePersistence();
    } catch (err) {
        if (!['failed-precondition', 'unimplemented'].includes(err.code)) {
            console.error('Firestore persistence error', err.stack || err);
        }
    }

    try {
        // only connect to local firebase emulator if FB_EMULATOR is set to true
        if (process.env.FB_EMULATOR === 'true' && !emulatorConnected) {
            db.useEmulator('localhost', 8080);
            emulatorConnected = true;
        }
    } catch (error) {}

    return db;
};

export const getDatabase = async () => {
    if (database) {
        return database;
    }

    if (!databasePromise) {
        databasePromise = loadDatabase();
    }

    database = await databasePromise;
    return database;
};

export const getDatabase$ = from(getDatabase());

export default getDatabase;
